import { useId } from "react";

type Props = {
  startColor: string;
  endColor: string;
};

export default function IconLetterCaseToggle({ startColor, endColor }: Props) {
  const gradientId = useId();

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1667 20.5837V9.20866C15.1667 8.20305 15.5661 7.23862 16.2772 6.52755C16.9883 5.81647 17.9527 5.41699 18.9583 5.41699C19.9639 5.41699 20.9284 5.81647 21.6394 6.52755C22.3505 7.23862 22.75 8.20305 22.75 9.20866V20.5837M15.1667 14.0835H22.75M10.8333 13.0003V20.5836M3.25 16.7919C3.25 17.2899 3.34807 17.7829 3.53862 18.2429C3.72917 18.703 4.00846 19.121 4.36055 19.473C4.71264 19.8251 5.13063 20.1044 5.59066 20.295C6.05068 20.4855 6.54374 20.5836 7.04167 20.5836C7.5396 20.5836 8.03265 20.4855 8.49268 20.295C8.9527 20.1044 9.37069 19.8251 9.72278 19.473C10.0749 19.121 10.3542 18.703 10.5447 18.2429C10.7353 17.7829 10.8333 17.2899 10.8333 16.7919C10.8333 16.294 10.7353 15.8009 10.5447 15.3409C10.3542 14.8809 10.0749 14.4629 9.72278 14.1108C9.37069 13.7587 8.9527 13.4794 8.49268 13.2889C8.03265 13.0983 7.5396 13.0003 7.04167 13.0003C6.54374 13.0003 6.05068 13.0983 5.59066 13.2889C5.13063 13.4794 4.71264 13.7587 4.36055 14.1108C4.00846 14.4629 3.72917 14.8809 3.53862 15.3409C3.34807 15.8009 3.25 16.294 3.25 16.7919Z"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="3.25"
          y1="5.41699"
          x2="17.95"
          y2="24.317"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={endColor} />
        </linearGradient>
      </defs>
    </svg>
  );
}
